module.exports = __webpack_public_path__ + "img/20.c0ecbd1c.png";